import type { VetCustomPlanType } from '@farmersdog/lead-browser-storage';
import { referredByVet } from '@farmersdog/lead-browser-storage';

import { useVetCreatePlanSignup } from '../experiments/useVetCreatePlanSignup';

import { useVetCustomPlanContext } from './context';

export function useVetCustomizedPlan(): VetCustomPlanType {
  const { isVetCreatePlanSignupOn } = useVetCreatePlanSignup();
  const planContext = useVetCustomPlanContext();

  if (!isVetCreatePlanSignupOn) {
    return undefined;
  }

  const sessionStorageReferredByVet = referredByVet.getParsed();

  return sessionStorageReferredByVet ?? planContext ?? undefined;
}
